(function () {
  'use strict';

  angular
      .module('tfc.retailer.CollapsibleBox')
      .directive('tfcCollapsibleBox', tfcCollapsibleBox)
      .controller('CollapsibleBoxCtrl', CollapsibleBoxCtrl)
      .directive('tfcCollapsibleBoxTransclude', tfcCollapsibleBoxTransclude);

  // tfc-collapsible-box-title, which defaults to an h4 containing the title argument,
  // or you can use the fit-box-title to have custom HTML for above the box
  createTranscludedPortionDirective('Title');

  // @ngInject
  function CollapsibleBoxCtrl() {
    var vm = this;

    vm.setTitle = function (tmpl) {
      this.titleTmpl = tmpl;
    };
  }

  // @ngInject
  function tfcCollapsibleBox() {
    return {
      restrict : 'E',
      replace : true,
      transclude : true,
      bindToController : true,
      controller : 'CollapsibleBoxCtrl as vm',
      templateUrl : 'Util/CollapsibleBox/CollapsibleBox.tmpl.html',
      scope : {}
    };
  }

  function createTranscludedPortionDirective(name) {
    angular
      .module('tfc.retailer.CollapsibleBox')
        .directive('tfcCollapsibleBox' + name, function () {
          return {
            restrict : 'E',
            transclude : true,
            template : '',
            replace : true,
            require : '^tfcCollapsibleBox',
            link : function ($scope, $el, $attr, tfcCollapsibleBox, transclude) {
              tfcCollapsibleBox['set' + name](transclude());
            }
          };
        });
  }

  // @ngInject
  function tfcCollapsibleBoxTransclude() {
    return {
      require : '^tfcCollapsibleBox',
      link : function ($scope, $el, $attrs, tfcCollapsibleBox) {
        $scope.$watch(
            function () {
              return tfcCollapsibleBox[$attrs.tfcCollapsibleBoxTransclude]
            },
            function (html) {
              if (html != null) {
                $el.html('');
                $el.append(html);
              }
            }
        );
      }
    };
  }

})();